import React from "react";
import { Text, TextInput, useTheme, type TextInputProps } from "react-native-paper";

export type TextInputV2Props = TextInputProps & {
    errorMessage?: string;
};
const TextInputV2: React.FC<TextInputV2Props> = (props) => {
    const theme = useTheme();

    return <>
        <TextInput
            {...props}
            error={!!props.errorMessage}
        />
        <Text style={{
            color: theme.colors.error,
        }}>{props.errorMessage}</Text>
    </>;
};

export default TextInputV2;

